import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.056 16.338a1.5 1.5 0 0 1 1.888 0L18 20.433V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v16.433l5.056-4.095zM7 2h10a2 2 0 0 1 2 2v17.482a.5.5 0 0 1-.815.388l-5.87-4.755a.5.5 0 0 0-.63 0l-5.87 4.755A.5.5 0 0 1 5 21.482V4a2 2 0 0 1 2-2z"
});

var SvgSaveForLater = function SvgSaveForLater(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgSaveForLater;